const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID || 'G-YFS93Q03PF';
const CONSENT_KEY = 'portfolio-analytics-consent';
let initialized = false;
let lastPageView = null;

export const getAnalyticsConsent = () => {
  try { return window.localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const initGA = () => {
  if (typeof window === 'undefined' || getAnalyticsConsent() !== 'granted') return false;
  if (initialized) return true;
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  if (!document.getElementById('portfolio-ga')) {
    const script = document.createElement('script');
    script.id = 'portfolio-ga';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
  initialized = true;
  return true;
};

export const setAnalyticsConsent = allowed => {
  try { window.localStorage.setItem(CONSENT_KEY, allowed ? 'granted' : 'denied'); } catch { return false; }
  if (allowed) {
    lastPageView = null;
    initGA();
    window.gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  } else {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    document.getElementById('portfolio-ga')?.remove();
    const names = document.cookie.split(';').map(cookie => cookie.split('=')[0].trim()).filter(name => /^_ga($|_)/.test(name));
    const hosts = window.location.hostname.split('.');
    for (const name of names) {
      document.cookie = `${name}=; Max-Age=0; path=/`;
      for (let index = 0; index < hosts.length - 1; index += 1) document.cookie = `${name}=; Max-Age=0; path=/; domain=${hosts.slice(index).join('.')}`;
    }
    initialized = false;
    lastPageView = null;
  }
  return true;
};

export const logPageView = (path = window.location.pathname, title = document.title) => {
  if (!initGA() || path === lastPageView) return;
  lastPageView = path;
  window.gtag('event', 'page_view', { page_path: path, page_title: title, page_location: new URL(path, window.location.origin).href });
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (initGA()) window.gtag('event', eventName, eventParams);
};

export const analytics = {
  trackNavigation: destination => trackEvent('navigation', { destination_path: destination }),
  trackCVDownload: source => trackEvent('cv_download_click', { source, file_name: 'CV2026-RaySaracual.pdf' }),
  trackExternalLink: (platform, url) => trackEvent('external_link_click', { platform, destination_url: url }),
  trackMenuInteraction: (action, item) => trackEvent('menu_interaction', { action, item }),
  trackTimeOnPage: (pageName, seconds) => trackEvent('time_on_page', { page_name: pageName, value: Math.round(seconds) }),
  trackScrollDepth: depth => trackEvent('scroll_depth', { value: depth }),
  trackProjectHover: projectName => trackEvent('project_hover', { project_name: projectName }),
  trackContactClick: source => trackEvent('contact_click', { source, method: 'whatsapp' }),
};
